import hoistNonReactStatistics from 'hoist-non-react-statics';
import React from 'react';
import type { OptionTypeBase } from 'react-select';
import ReactSelect from 'react-select';
import InputSkeleton from '../components/input-skeleton';
import AbstractSelect from './abstract-select';
import type { ClassicSelectProps } from './select.types';

const Select = <
  OptionType extends OptionTypeBase = { label: React.ReactNode; value: any },
  IsMulti extends boolean = false,
>(
  props: ClassicSelectProps<OptionType, IsMulti>,
  ref?: React.Ref<ReactSelect>,
) => <AbstractSelect ref={ref} {...props} Component={ReactSelect as any} />;

Select.Prefix = InputSkeleton.Prefix;
Select.Icon = InputSkeleton.Icon;

export default hoistNonReactStatistics(React.forwardRef(Select), Select) as typeof Select;
